import { push } from 'react-router-redux';
import { tryToFetchDocFeaturedMedia } from '../actions.export';

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// doc list 
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestDocs = credentials => {
  return {
    type: 'REQUEST_DOCS'
  }
}

export const receiveDocsSuccess = data => ({
  type: 'RECEIVE_DOCS_SUCCESS',
  data
})

export const receiveDocsFail = data => ({
  type: 'RECEIVE_DOCS_FAIL',
  data
})

export const tryToFetchDocs = packet => dispatch => {
  dispatch(requestDocs());
  
  let queryString = "";
  if(packet) queryString = Object.keys(packet).map(key => key + '=' + packet[key]).join('&');

  
  return fetch('/api/docs/multiple?' + queryString, {
    method: 'get',
    headers: {
      "Content-Type": "application/json"
    }
  })
  .then((response) => {
    let json = response.json();
    if (response.status >= 200 && response.status < 300) return json;
    return json.then(Promise.reject.bind(Promise));
  })
  .then(function(json){


    json.queryString = queryString;
    json.queryParams = packet || {};

    // if(json.posts.length == 0 && (window.location.pathname == '/docs' || window.location.pathname.indexOf('/docs/with/tag/') === 0 || window.location.pathname.indexOf('/docs/in/category/') === 0)){
      // dispatch(push('/'));
    // }

    // console.log(json);

    for(var i in json.posts){
      if(json.posts[i]._links['wp:featuredmedia']){
        dispatch(tryToFetchDocFeaturedMedia(json.posts[i]));
      }
    }

    return dispatch(receiveDocsSuccess(json));
  })
  .catch(e => {
    dispatch(receiveDocsFail({error:e, packet: packet}));
  })
}



// WEBPACK FOOTER //
// ./src/actions/docs/a.d.GET.multiple.js